// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_wrapper__Iu-6q .Login_title__v2O5z {
  font-size: 48px;
  font-weight: 700;
  font-style: normal;
  color: #FFFFFF;
  margin-top: 40px;
  text-align: center;
}
.Login_wrapper__Iu-6q .Login_select__YGLoz {
  background-color: rgba(220, 220, 220, 0.1019607843);
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  height: 56px;
  margin-top: 24px;
  padding: 1px;
}
.Login_wrapper__Iu-6q .Login_select__YGLoz .Login_selectItem__E6nzI {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  align-items: center;
  color: #E0E0E0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 33%;
}
.Login_wrapper__Iu-6q .Login_select__YGLoz .Login_selected__nhLYI {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  background-color: rgba(0, 0, 0, 0.3019607843);
  border-radius: 11px;
  color: #ffffff;
}
.Login_wrapper__Iu-6q .Login_steam__-IKVE {
  text-align: center;
}
.Login_wrapper__Iu-6q .Login_subtitle__oe4Za {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  align-items: center;
  color: #ffffff;
  display: flex;
  gap: 18px;
  margin-bottom: 24px;
  margin-top: 24px;
  white-space: nowrap;
}
.Login_wrapper__Iu-6q .Login_subtitle__oe4Za .Login_line__csqF4 {
  background-color: rgba(220, 220, 220, 0.1);
  height: 1px;
  width: 100%;
}
.Login_wrapper__Iu-6q .Login_firstRow__W80Iz {
  margin-top: 24px;
}
.Login_wrapper__Iu-6q .Login_errorMessage__SlobN {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #F44336;
  margin-top: 16px;
  text-align: center;
}
.Login_wrapper__Iu-6q .Login_row__jllZw {
  margin-bottom: 20px;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_label__wtT4w {
  color: #ffffff;
  margin-bottom: 12px;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_label__wtT4w span {
  color: #F44336;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_input__h9wP1 {
  align-items: center;
  background-color: rgba(220, 220, 220, 0.1);
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  height: 56px;
  padding-left: 12px;
  padding-right: 12px;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_input__h9wP1 .Login_inputWrapper__JBigD {
  width: 100%;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_input__h9wP1 .Login_inputWrapper__JBigD input {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  background-color: unset;
  border: unset;
  color: #E0E0E0;
  outline: unset;
  width: 100%;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_input__h9wP1 .Login_inputWrapper__JBigD input::placeholder {
  color: #E0E0E0;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_input__h9wP1 .Login_eye__graKP {
  align-items: center;
  cursor: pointer;
  display: flex;
  transition: all 0.2s linear;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_input__h9wP1 .Login_eye__graKP svg path {
  fill: #E0E0E0;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_input__h9wP1 .Login_eye__graKP:hover svg path {
  fill: #ffffff;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_inputFocus__sSdmy {
  border: 1px solid #FD4C0A;
  transition: all 0.2s linear;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_condition__Qie56 {
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  margin-top: 8px;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_condition__Qie56 .Login_conditionItem__XOmVq {
  align-items: center;
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_offer__07mIt {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  align-items: center;
  background-color: rgba(220, 220, 220, 0.1);
  border-radius: 8px;
  color: #E0E0E0;
  display: flex;
  gap: 10px;
  height: 56px;
  justify-content: space-between;
  margin-top: 20px;
  padding-left: 16px;
  padding-right: 16px;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_offer__07mIt span {
  color: #EAD40C;
  cursor: pointer;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_offer__07mIt label {
  cursor: pointer;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_offer__07mIt label input {
  display: none;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_btn__iuJu- {
  margin-top: 32px;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_btn__iuJu- button {
  width: 100%;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_enter__4MPHe {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  margin-top: 32px;
  text-align: center;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_enter__4MPHe span {
  color: #EAD40C;
  cursor: pointer;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_error__F3FwH {
  border: 1px solid #F44336;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_errorTxt__irSYt {
  color: #F44336;
}
.Login_wrapper__Iu-6q .Login_row__jllZw .Login_help__rBWd5 {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #EAD40C;
  cursor: pointer;
  margin-top: 32px;
  text-align: center;
}
.Login_wrapper__Iu-6q .Login_regOffer__AN6g2 {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  line-height: 150%;
  text-align: center;
}
.Login_wrapper__Iu-6q .Login_regOfferBtn__Haa4V {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #FD4C0A;
  cursor: pointer;
  text-align: center;
  text-decoration: underline;
}
.Login_wrapper__Iu-6q .Login_rowLast__yhN5P {
  margin-bottom: 0;
}

@media (max-width: 850px) {
  .Login_wrapper__Iu-6q {
    width: 100%;
  }
  .Login_wrapper__Iu-6q .Login_title__v2O5z {
    font-size: 32px;
  }
  .Login_wrapper__Iu-6q .Login_select__YGLoz .Login_selectItem__E6nzI {
    font-size: 13px;
    font-weight: 400;
    font-style: normal;
  }
  .Login_wrapper__Iu-6q .Login_select__YGLoz .Login_selected__nhLYI {
    font-size: 13px;
    font-weight: 500;
    font-style: normal;
  }
  .Login_wrapper__Iu-6q .Login_subtitle__oe4Za {
    font-size: 16px;
  }
  .Login_wrapper__Iu-6q .Login_row__jllZw .Login_enter__4MPHe {
    font-size: 16px;
  }
  .Login_wrapper__Iu-6q .Login_row__jllZw .Login_help__rBWd5 {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/Login/Login.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAIE;ECGA,eAAA;EACA,gBAAA;EACA,kBAAA;EDFE,cAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;AAKE;EACE,mDAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAHJ;AAKI;ECwCF,eAAA;EACA,gBAAA;EACA,kBAAA;EDvCI,mBAAA;EACA,cEnBS;EFoBT,eAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;AAFN;AAKI;ECiBF,eAAA;EACA,gBAAA;EACA,kBAAA;EDhBI,6CAAA;EACA,mBAAA;EACA,cErCI;AFmCV;AAME;EACE,kBAAA;AAJJ;AAOE;ECFA,eAAA;EACA,gBAAA;EACA,kBAAA;EDGE,mBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAJJ;AAMI;EACE,0CAAA;EACA,WAAA;EACA,WAAA;AAJN;AAQE;EACE,gBAAA;AANJ;AASE;ECNA,eAAA;EACA,gBAAA;EACA,kBAAA;EDOE,cAAA;EACA,gBAAA;EACA,kBAAA;AANJ;AASE;EACE,mBAAA;AAPJ;AASI;EACE,cAAA;EACA,mBAAA;AAPN;AASM;EACE,cAAA;AAPR;AAWI;EACE,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AATN;AAWM;EACE,WAAA;AATR;AAWQ;ECvCN,eAAA;EACA,gBAAA;EACA,kBAAA;EDwCQ,uBAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;AARV;AAUU;EACE,cAAA;AARZ;AAaM;EACE,mBAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;AAXR;AAcU;EACE,aAAA;AAZZ;AAgBQ;EACE,aAAA;AAdV;AAmBI;EGjGF,yBAAA;EACA,2BAAA;AHiFF;AAmBI;ECtEF,eAAA;EACA,gBAAA;EACA,kBAAA;EDuEI,cAAA;EACA,eAAA;AAhBN;AAkBM;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;AAhBR;AAoBI;EC1FF,eAAA;EACA,gBAAA;EACA,kBAAA;ED2FI,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAjBN;AAmBM;EACE,cAAA;EACA,eAAA;AAjBR;AAoBM;EACE,eAAA;AAlBR;AAoBQ;EACE,aAAA;AAlBV;AAuBI;EACE,gBAAA;AArBN;AAuBM;EACE,WAAA;AArBR;AAyBI;ECvJF,eAAA;EACA,gBAAA;EACA,kBAAA;EDwJI,cAAA;EACA,gBAAA;EACA,kBAAA;AAtBN;AAwBM;EACE,cAAA;EACA,eAAA;AAtBR;AA0BI;EACE,yBAAA;AAxBN;AA2BI;EACE,cAAA;AAzBN;AA4BI;ECtKF,eAAA;EACA,gBAAA;EACA,kBAAA;EDuKI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAzBN;AA6BE;EC9JA,eAAA;EACA,gBAAA;EACA,kBAAA;ED+JE,cExNW;EFyNX,iBAAA;EACA,kBAAA;AA1BJ;AA6BE;ECtKA,eAAA;EACA,gBAAA;EACA,kBAAA;EDuKE,cE7NO;EF8NP,eAAA;EACA,kBAAA;EACA,0BAAA;AA1BJ;AA6BE;EACE,gBAAA;AA3BJ;;AA+BA;EACE;IACE,WAAA;EA5BF;EA8BE;IACE,eAAA;EA5BJ;EAiCI;ICpJJ,eAAA;IACA,gBAAA;IACA,kBAAA;EDsHA;EAgCI;IC1KJ,eAAA;IACA,gBAAA;IACA,kBAAA;ED6IA;EAgCE;IACE,eAAA;EA9BJ;EAkCI;IACE,eAAA;EAhCN;EAmCI;IACE,eAAA;EAjCN;AACF","sourcesContent":["@import '../../../assets/styles/global.scss';\n\n.wrapper {\n\n  .title {\n    @include h2;\n\n    color: #FFFFFF;\n    margin-top: 40px;\n    text-align: center;\n  }\n\n  .select {\n    background-color: #DCDCDC1A;\n    border-radius: 12px;\n    display: flex;\n    justify-content: space-between;\n    height: 56px;\n    margin-top: 24px;\n    padding: 1px;\n\n    .selectItem {\n      @include body1;\n\n      align-items: center;\n      color: $c-light-grey;\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n      width: 33%;\n    }\n\n    .selected {\n      @include subtitle6m;\n\n      background-color: #0000004D;\n      border-radius: 11px;\n      color: $c-white;\n    }\n  }\n\n  .steam {\n    text-align: center;\n  }\n\n  .subtitle {\n    @include subtitle5;\n\n    align-items: center;\n    color: #ffffff;\n    display: flex;\n    gap: 18px;\n    margin-bottom: 24px;\n    margin-top: 24px;\n    white-space: nowrap;\n\n    .line {\n      background-color: rgba(220, 220, 220, .1);\n      height: 1px;\n      width: 100%;\n    }\n  }\n\n  .firstRow {\n    margin-top: 24px;\n  }\n\n  .errorMessage {\n    @include body1;\n\n    color: #F44336;\n    margin-top: 16px;\n    text-align: center;\n  }\n\n  .row {\n    margin-bottom: 20px;\n\n    .label {\n      color: #ffffff;\n      margin-bottom: 12px;\n\n      span {\n        color: #F44336;\n      }\n    }\n\n    .input {\n      align-items: center;\n      background-color: rgba(220, 220, 220, .1);\n      border-radius: 8px;\n      display: flex;\n      justify-content: space-between;\n      height: 56px;\n      padding-left: 12px;\n      padding-right: 12px;\n\n      .inputWrapper {\n        width: 100%;\n\n        input {\n          @include body1;\n\n          background-color: unset;\n          border: unset;\n          color: #E0E0E0;\n          outline: unset;\n          width: 100%;\n\n          &::placeholder {\n            color: #E0E0E0;\n          }\n        }\n      }\n\n      .eye {\n        align-items: center;\n        cursor: pointer;\n        display: flex;\n        transition: all .2s linear;\n\n        svg {\n          path {\n            fill: #E0E0E0;\n          }\n        }\n\n        &:hover svg path {\n          fill: #ffffff;\n        }\n      }\n    }\n\n    .inputFocus {\n      @include borderYellow;\n    }\n\n    .condition {\n      @include body2;\n\n      color: #E0E0E0;\n      margin-top: 8px;\n\n      .conditionItem {\n        align-items: center;\n        display: flex;\n        gap: 4px;\n        margin-bottom: 4px;\n      }\n    }\n\n    .offer {\n      @include body1;\n\n      align-items: center;\n      background-color: rgba(220, 220, 220, .1);\n      border-radius: 8px;\n      color: #E0E0E0;\n      display: flex;\n      gap: 10px;\n      height: 56px;\n      justify-content: space-between;\n      margin-top: 20px;\n      padding-left: 16px;\n      padding-right: 16px;\n\n      span {\n        color: #EAD40C;\n        cursor: pointer;\n      }\n\n      label {\n        cursor: pointer;\n\n        input {\n          display: none;\n        }\n      }\n    }\n\n    .btn {\n      margin-top: 32px;\n\n      button {\n        width: 100%;\n      }\n    }\n\n    .enter {\n      @include subtitle4m;\n\n      color: #ffffff;\n      margin-top: 32px;\n      text-align: center;\n\n      span {\n        color: #EAD40C;\n        cursor: pointer;\n      }\n    }\n\n    .error {\n      border: 1px solid #F44336;\n    }\n\n    .errorTxt {\n      color: #F44336;\n    }\n\n    .help {\n      @include subtitle5;\n\n      color: #EAD40C;\n      cursor: pointer;\n      margin-top: 32px;\n      text-align: center;\n    }\n  }\n\n  .regOffer {\n    @include body1;\n\n    color: $c-light-grey;\n    line-height: 150%;\n    text-align: center;\n  }\n\n  .regOfferBtn {\n    @include body1;\n\n    color: $c-yellow;\n    cursor: pointer;\n    text-align: center;\n    text-decoration: underline;\n  }\n\n  .rowLast {\n    margin-bottom: 0;\n  }\n}\n\n@media (max-width: 850px) {\n  .wrapper {\n    width: 100%;\n\n    .title {\n      font-size: 32px;\n    }\n\n    .select {\n\n      .selectItem {\n        @include tableinput;\n      }\n\n      .selected {\n        @include buttonsmall;\n      }\n    }\n\n    .subtitle {\n      font-size: 16px;\n    }\n\n    .row {\n      .enter {\n        font-size: 16px;\n      }\n\n      .help {\n        font-size: 16px;\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #FD4C0A;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n\n\n","@mixin df {\n  display: flex;\n}\n\n@mixin df-aic {\n  align-items: center;\n  display: flex;\n}\n\n@mixin df-aic-g8 {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n@mixin df-aic-jcc {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n@mixin df-aic-jcsb {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n@mixin hoverYellow {\n  transition: all .2s linear;\n\n  &:hover {\n    color: $c-yellow;\n  }\n}\n\n@mixin borderYellow {\n  border: 1px solid $c-yellow;;\n  transition: all .2s linear;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Login_wrapper__Iu-6q`,
	"title": `Login_title__v2O5z`,
	"select": `Login_select__YGLoz`,
	"selectItem": `Login_selectItem__E6nzI`,
	"selected": `Login_selected__nhLYI`,
	"steam": `Login_steam__-IKVE`,
	"subtitle": `Login_subtitle__oe4Za`,
	"line": `Login_line__csqF4`,
	"firstRow": `Login_firstRow__W80Iz`,
	"errorMessage": `Login_errorMessage__SlobN`,
	"row": `Login_row__jllZw`,
	"label": `Login_label__wtT4w`,
	"input": `Login_input__h9wP1`,
	"inputWrapper": `Login_inputWrapper__JBigD`,
	"eye": `Login_eye__graKP`,
	"inputFocus": `Login_inputFocus__sSdmy`,
	"condition": `Login_condition__Qie56`,
	"conditionItem": `Login_conditionItem__XOmVq`,
	"offer": `Login_offer__07mIt`,
	"btn": `Login_btn__iuJu-`,
	"enter": `Login_enter__4MPHe`,
	"error": `Login_error__F3FwH`,
	"errorTxt": `Login_errorTxt__irSYt`,
	"help": `Login_help__rBWd5`,
	"regOffer": `Login_regOffer__AN6g2`,
	"regOfferBtn": `Login_regOfferBtn__Haa4V`,
	"rowLast": `Login_rowLast__yhN5P`
};
export default ___CSS_LOADER_EXPORT___;
